var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 76,
    viewBox: "0 0 100 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.75 75.5001H6.25004C2.79812 75.5001 0 72.7018 0 69.2501C0 65.7984 2.79812 63.0001 6.25004 63.0001H93.7502C97.2019 63.0001 100 65.7984 100 69.2501C100 72.7018 97.2019 75.5001 93.75 75.5001ZM93.75 44.2499H6.25004C2.79812 44.2499 0 41.4518 0 38.0001C0 34.5484 2.79812 31.7501 6.25004 31.7501H93.7502C97.2019 31.7501 100 34.5482 100 38.0001C100 41.452 97.2019 44.2499 93.75 44.2499ZM93.75 13H6.25004C2.79812 13 0 10.2018 0 6.74992C0 3.298 2.79812 0.499878 6.25004 0.499878H93.7502C97.2019 0.499878 100 3.298 100 6.74992C100 10.2018 97.2019 13 93.75 13Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.6c4fc9bb2b4b51d64932a19261f82cf1.svg";
export { ForwardRef as ReactComponent };